"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTabsWrapper = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _StyledTabsWrapper = require("./StyledTabsWrapper.styles");
var _components = require("./components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var StyledTabsWrapper = function StyledTabsWrapper(props) {
  var tabTitles = props.tabTitles,
    tabIndex = props.tabIndex,
    _props$tabName = props.tabName,
    tabName = _props$tabName === void 0 ? 'tab' : _props$tabName,
    className = props.className,
    handleChange = props.handleChange,
    testId = props.testId,
    disabledTabs = props.disabledTabs,
    _props$iconTitles = props.iconTitles,
    iconTitles = _props$iconTitles === void 0 ? false : _props$iconTitles;
  var _useStyles = (0, _StyledTabsWrapper.useStyles)({
      iconTitles: iconTitles
    }),
    tab = _useStyles.tab,
    selected = _useStyles.selected,
    notSelected = _useStyles.notSelected,
    spacer = _useStyles.spacer,
    indicator = _useStyles.indicator;
  return /*#__PURE__*/_react["default"].createElement(_components.TabsWrapper, {
    "data-testid": testId,
    className: className,
    value: tabIndex,
    indicatorColor: "primary",
    TabIndicatorProps: {
      className: indicator
    }
  }, tabTitles.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_components.Tab, _extends({
      key: index,
      "data-testid": "tab-".concat(index),
      className: tab,
      disabled: disabledTabs === null || disabledTabs === void 0 ? void 0 : disabledTabs.includes(index),
      onClick: function onClick() {
        return handleChange(index);
      }
    }, (0, _components.getAttrProps)(index, tabName), {
      label: /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(tabIndex === index ? selected : notSelected)
      }, item, iconTitles && index !== tabTitles.length - 1 && /*#__PURE__*/_react["default"].createElement("div", {
        className: spacer
      }))
    }));
  }));
};
exports.StyledTabsWrapper = StyledTabsWrapper;